import { environmentv3 } from 'src/environments/environmentv3';
import { environment } from 'src/environments/environment';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';

import { Injectable } from "@angular/core";
import { ApiController } from "../api-controller.interface";
import { EspecieVeiculo } from '@tivic-team/manager-ts/dist/fta';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';

@Injectable()
export class EspecieVeiculoController implements ApiController<EspecieVeiculo> {

    constructor () {}

    find(filters?: IFilter): Promise<EspecieVeiculo[]> {
        let request = new Quark(
            new HttpGet ({
                url: new Url({
                    id: 'fta/especieveiculo',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new Array<EspecieVeiculo>())
        );
        return request.call();
    }

    get(id: number): Promise<EspecieVeiculo> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'fta/especieveiculo/:cdEspecie',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdEspecie: id
                    }),
                }),
            }),
            new HttpResponse(new EspecieVeiculo)
        );
        return request.call();
    }

    create(entity: EspecieVeiculo): Promise<EspecieVeiculo> {
        let request = new Quark (
            new HttpPost({
                url: new Url({
                    id: 'fta/especieveiculo',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new EspecieVeiculo()
            )
        );
        return request.call();
    }
    
    update(entity: EspecieVeiculo): Promise<EspecieVeiculo> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'fta/especieveiculo/:cdEspecie',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdEspecie: entity.cdEspecie
                    }),
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new EspecieVeiculo()
            )
        );
        return request.call();
    }
    
}
